module.exports = __webpack_public_path__ + "static/img/copper_three.d7044d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copper_three.png
// module id = VXGs
// module chunks = 1